export default "__VITE_ASSET__CuwCV2Ab__"